import type { CrudOperation, KnowledgeGraph } from '@/types/knowledge_graph'
import { CrudLetterBadge } from '../components/CrudLetterBadge'

interface Props {
  matrix: KnowledgeGraph['permission_matrix']
}

const CRUD_OPERATIONS: CrudOperation[] = ['create', 'read', 'update', 'delete']

const CRUD_OPERATION_INITIAL: Record<CrudOperation, string> = {
  create: 'C',
  read: 'R',
  update: 'U',
  delete: 'D'
}

export function MatrixTab ({ matrix }: Props): React.ReactElement {
  if ((matrix == null) || matrix.actors == null || matrix.actors.length === 0 || matrix.rows == null || matrix.rows.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '40px 0', color: 'var(--bp-ink3)', fontSize: 14 }}>
        権限マトリクスがありません
      </div>
    )
  }

  const { actors, rows } = matrix
  const entities = [...new Set(rows.map((r) => r.entity))]

  return (
    <div>
      <div className='section-head'><h3>権限マトリクス（Actor × Entity）</h3></div>
      <div className='matrix-wrap'>
        <table className='matrix-table'>
          <thead>
            <tr>
              <th className='actor-col'>アクター</th>
              {entities.map((entity) => (
                <th key={entity} style={{ textAlign: 'center' }}>{entity}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {actors.map((actor) => (
              <tr key={actor}>
                <td className='actor-col'>{actor}</td>
                {entities.map((entity) => (
                  <td key={entity} className='matrix-cell'>
                    <div style={{ display: 'flex', gap: 3, justifyContent: 'center' }}>
                      {CRUD_OPERATIONS.map((op) => {
                        const row = rows.find((r) => r.entity === entity && r.operation === op)
                        const value = row?.permissions?.[actor]
                        const uncertain = row?.uncertain_actors?.includes(actor) === true
                        return (
                          <CrudLetterBadge
                            key={op}
                            initial={CRUD_OPERATION_INITIAL[op]}
                            value={value}
                            uncertain={uncertain}
                            followupQuestion={uncertain ? row?.followup_question : undefined}
                          />
                        )
                      })}
                    </div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className='matrix-legend'>
        <span>C/R/U/D = 作成/参照/更新/削除</span>
        <span style={{ color: 'var(--bp-ok)', fontWeight: 700 }}>文字色=許可</span>
        <span style={{ color: 'var(--bp-warning)', fontWeight: 700 }}>文字色=要確認（ホバーで詳細）</span>
        <span style={{ color: 'var(--bp-ink3)' }}>− 禁止・未定義</span>
      </div>
    </div>
  )
}
